module.exports = __webpack_public_path__ + "7a42dc712c1bb480831697a462132ae7.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ClanWebPro-News.eot
// module id = 71
// module chunks = 0